import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=7202c9ce&scoped=true"
import script from "./Assistance.vue?vue&type=script&lang=ts"
export * from "./Assistance.vue?vue&type=script&lang=ts"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=7202c9ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202c9ce",
  null
  
)

export default component.exports